/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-10-15 10:32:01
 * @LastEditors: susj
 * @LastEditTime: 2020-10-15 17:18:13
 */

import request from '@/utils/request';

const requestInstance = request();
export default {
  // 新建空白slide
  slideWrapCreate(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/create', params);
  },
  // 复制slide
  slideWrapCopySlide(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/copySlide', params);
  },
  // 删除幻灯片slide，id，pptId 是必须的
  slideWrapDelSlide(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/delSlide', params);
  },
  // ppt 下的slide重新排序,找不到的slide会删除
  slideWrapSlideSort(params) {
    return requestInstance.post('/api/schemeshow/slideWrap/slideSort', params);
  },
};
